export type URLSchemeType = { [key: string]: string | URLSchemeType };

const API_BASE = '/api/v1';
const DASHBOARD_BASE = `${API_BASE}/dashboard`;

const API_ESHOP = `${API_BASE}/eshop`;
const API_ERP = `${API_BASE}/erp`;
const API_CRM = `${API_BASE}/crm`;
const DASHBOARD_ESHOP = `${API_BASE}/eshop/dashboard`;
// const DASHBOARD_ESHOP = `${DASHBOARD_BASE}/eshop`;

const URLScheme: URLSchemeType = {
  auth: {
    login: `${API_BASE}/auth/login`,                  // auth:login
    logout: `${API_BASE}/auth/logout`,                // auth:logout
    refresh: `${API_BASE}/auth/refresh`,              // auth:refresh
    session: `${API_BASE}/auth/session`,
    reset_pass: `${API_BASE}/auth/password/reset`,    // auth:reset_pass
    register: `${API_BASE}/auth/register/staff`,      // auth:register
    code: `${API_BASE}/auth/code`,                    // auth:code
    select_profile: `${API_BASE}/auth/select-profile`, // auth:select_profile
    switch_profile: `${API_BASE}/auth/switch-profile`, // auth:switch_profile
    return_to_origin: `${API_BASE}/auth/return-to-origin`, // auth:return_to_origin
    my_relationships: `${API_BASE}/auth/my-relationships`, // auth:my_relationships
    roles: `${API_BASE}/auth/roles`,                  // auth:roles
    password: {
      request_reset: `${API_BASE}/auth/password/request-reset`, // auth:password:request_reset
      reset: `${API_BASE}/auth/password/reset`,                 // auth:password:reset
    },
    staff: {
      invite: `${API_BASE}/auth/staff/invite`,        // auth:staff:invite
    },
  },
  user: {
    me: `${API_BASE}/users/me`,                       // user:me
    update: `${API_BASE}/users/me`,                   // user:update
    staff_list: `${API_BASE}/users/staff/list`,       // user:staff_list
    address: `${API_BASE}/users/addresses`,           // user:address
    contact_request: `${API_BASE}/users/me/contact/request`, // user:contact_request
    contact_confirm: `${API_BASE}/users/me/contact/confirm`, // user:contact_confirm
    orders: `${API_BASE}/users/orders`,               // user:orders
  },
  account: {
    forms: {
      list: `${API_BASE}/account/forms`,
      detail: `${API_BASE}/account/forms/assignments`,
      draft: `${API_BASE}/account/forms/assignments`,
      submit: `${API_BASE}/account/forms/assignments`,
      revisions: `${API_BASE}/account/forms/assignments`,
      pdf: `${API_BASE}/account/forms/assignments`,
    },
    subscriptions: {
      list: `${API_BASE}/account/subscriptions`,
      payments: `${API_BASE}/account/subscriptions/payments`,
    },
    schedule: {
      upcoming: `${API_BASE}/account/schedule/upcoming`,
      agenda: `${API_BASE}/account/schedule/agenda`,
      enrollment_options: `${API_BASE}/account/schedule/group-enrollment-options`,
      enrollment_catalog: `${API_BASE}/account/schedule/group-enrollment-catalog`,
      enrollment_suggestions: `${API_BASE}/account/schedule/group-enrollment-suggestions`,
      event_enrollments: `${API_BASE}/account/schedule/groups`,
      appointments: `${API_BASE}/account/schedule/appointments`,
      appointment_visits: `${API_BASE}/account/schedule/appointment-visits`,
      group_events: `${API_BASE}/account/schedule/group-events`,
      memberships: `${API_BASE}/account/schedule/groups`,
      group_memberships: `${API_BASE}/account/schedule/group-memberships`,
    },
  },
  forms: {
    admin: {
      definitions: `${API_BASE}/forms/admin/definitions`,
      presets: `${API_BASE}/forms/admin/presets`,
      'access-groups': `${API_BASE}/forms/admin/access-groups`,
      access_groups: `${API_BASE}/forms/admin/access-groups`,
    },
    staff: {
      assignments: `${API_BASE}/forms/staff/assignments`,
      revisions: `${API_BASE}/forms/staff/revisions`,
      export: `${API_BASE}/forms/staff/export`,
    },
  },
  users: {
    get_analytics: `${API_BASE}/users`,               // users:get_analytics (append userId/analytics)
  },
  dashboard: {
    stats: `${DASHBOARD_BASE}/stats`,                  // dashboard:stats (dashboard/admin)
  },
  settings: {
    public: `${API_BASE}/settings/public`,            // settings:public
    update: `${API_BASE}/settings`,                   // settings:update (incluye flags ERP)
    assets: `${API_BASE}/settings/assets`,            // settings:assets
    contact_whatsapp_request: `${API_BASE}/settings/contact/whatsapp/request`,
    contact_whatsapp_confirm: `${API_BASE}/settings/contact/whatsapp/confirm`,
  },
  media: {
    list: `${API_BASE}/media`,                        // media:list
  },
  suppliers: {
    base: `${API_BASE}/suppliers`,                    // suppliers:base
    payment_terms: `${API_BASE}/payment-terms`,       // suppliers:payment_terms
    addresses: `${API_BASE}/addresses`,               // suppliers:addresses
  },
  eshop: {
    items: `${API_ESHOP}/items`,                          // eshop:items
    items_bulk_toggle: `${DASHBOARD_ESHOP}/items/bulk-toggle`,  // eshop:items_bulk_toggle (dashboard/admin)
    items_select: `${API_ESHOP}/items/select`,            // eshop:items_select
    attributes: `${API_ESHOP}/item-class/attributes`,     // eshop:attributes
    // ← incorporado del esquema anterior (público)
    banners: `${API_ESHOP}/banners`,
    wishlist: {
      items: `${API_ESHOP}/wishlist/items`,              // eshop:wishlist:items
    },
    shipping: {
      active_list: `${API_ESHOP}/shipping-methods/public`,    // eshop:shipping:active_list
    },
    cart: {
      handler: `${API_ESHOP}/cart`,               // eshop:cart:handler
      line_handler: `${API_ESHOP}/cart/line`,     // eshop:cart:line_handler
      voucher: `${API_ESHOP}/cart/voucher`,       // eshop:cart:voucher
      merge: `${API_ESHOP}/cart/merge`,           // eshop:cart:merge
    },
    dashboard: {
      category: {
        create: `${DASHBOARD_ESHOP}/category`,        // eshop:dashboard:category:create (dashboard/admin)
        tree: `${DASHBOARD_ESHOP}/category/tree`,      // eshop:dashboard:category:tree (dashboard/admin)
      },
      image: {
        list: `${DASHBOARD_ESHOP}/image`,             // eshop:dashboard:image:list (dashboard/admin)
        upload: `${DASHBOARD_ESHOP}/image`,           // eshop:dashboard:image:upload (dashboard/admin)
        move: `${DASHBOARD_ESHOP}/image/move`,        // eshop:dashboard:image:move (dashboard/admin)
        update: `${DASHBOARD_ESHOP}/image`,           // eshop:dashboard:image:update (dashboard/admin)
        delete: `${DASHBOARD_ESHOP}/image`,           // eshop:dashboard:image:delete (dashboard/admin)
        delete_check: `${DASHBOARD_ESHOP}/image/delete-check`, // eshop:dashboard:image:delete_check (dashboard/admin)
        item_set: `${DASHBOARD_ESHOP}/image/item`,    // eshop:dashboard:image:item_set (dashboard/admin)
        folder: {
          list: `${DASHBOARD_ESHOP}/image/folder`,      // eshop:dashboard:image:folder:list (dashboard/admin)
          create: `${DASHBOARD_ESHOP}/image/folder`,    // eshop:dashboard:image:folder:create (dashboard/admin)
          update: `${DASHBOARD_ESHOP}/image/folder`,    // eshop:dashboard:image:folder:update (dashboard/admin)
          delete: `${DASHBOARD_ESHOP}/image/folder`,    // eshop:dashboard:image:folder:delete (dashboard/admin)
        },
      },
      item: {
        edit: `${DASHBOARD_ESHOP}/items`,         // eshop:dashboard:item:edit (dashboard/admin)
        export: `${DASHBOARD_ESHOP}/items/export`, // eshop:dashboard:item:export (dashboard/admin)
        add: `${DASHBOARD_ESHOP}/items`,          // eshop:dashboard:item:add (dashboard/admin)
        delete: `${DASHBOARD_ESHOP}/items`,       // eshop:dashboard:item:delete (dashboard/admin)
        restore: `${DASHBOARD_ESHOP}/items`,      // eshop:dashboard:item:restore (dashboard/admin)
        bulk_toggle: `${DASHBOARD_ESHOP}/items/bulk-toggle`,  // eshop:dashboard:item:bulk_toggle (dashboard/admin)
        bulk_price_preview: `${DASHBOARD_ESHOP}/items/bulk-price/preview`, // eshop:dashboard:item:bulk_price_preview (dashboard/admin)
        bulk_price_preview_detail: `${DASHBOARD_ESHOP}/items/bulk-price/preview`, // eshop:dashboard:item:bulk_price_preview_detail (dashboard/admin)
        bulk_price_commit: `${DASHBOARD_ESHOP}/items/bulk-price/commit`, // eshop:dashboard:item:bulk_price_commit (dashboard/admin)
        extra_attributes: `${DASHBOARD_ESHOP}/items/extra-attributes`, // eshop:dashboard:item:extra_attributes (dashboard/admin)
      },
      item_class: {
        create_class: `${DASHBOARD_ESHOP}/item-class/classes`,  // eshop:dashboard:item_class:create_class (dashboard/admin)
        create_attribute: `${DASHBOARD_ESHOP}/item-class/attributes`, // eshop:dashboard:item_class:create_attribute (dashboard/admin)
        update_attribute: `${DASHBOARD_ESHOP}/item-class/attributes`, // eshop:dashboard:item_class:update_attribute (dashboard/admin)
        list_attributes: `${DASHBOARD_ESHOP}/item-class/attributes/all`, // eshop:dashboard:item_class:list_attributes (dashboard/admin)
        list_global_attribute: `${DASHBOARD_ESHOP}/item-class/global/attributes`, // eshop:dashboard:item_class:list_global_units (dashboard/admin)
        list_global_units: `${DASHBOARD_ESHOP}/item-class/global/units`, // eshop:dashboard:item_class:list_global_units (dashboard/admin)
      },
      payment: {
        methods: `${DASHBOARD_ESHOP}/payment-methods`,   // eshop:dashboard:payment:methods (dashboard/admin)
        providers: `${DASHBOARD_ESHOP}/payment-providers`,       // eshop:dashboard:payment:providers (dashboard/admin)
      },
      coupons: `${DASHBOARD_ESHOP}/coupons`,            // eshop:dashboard:coupons (dashboard/admin)
      offers: `${DASHBOARD_ESHOP}/offers`,              // eshop:dashboard:offers (dashboard/admin)
      shipping: {
        methods_list: `${DASHBOARD_ESHOP}/shipping-methods`,    // eshop:dashboard:shipping:methods_list (dashboard/admin)
      },
      // ← incorporado del esquema anterior (dashboard)
      banners: `${DASHBOARD_ESHOP}/banners`,                 // eshop:dashboard:banners (dashboard/admin)
      catalogue_template: `${API_ESHOP}/catalogue/template`, // eshop:dashboard:catalogue:template (dashboard/admin)
    },
    catalogue: {
      get_datalist: `${API_ESHOP}/items`,           // eshop:catalogue:get_datalist
      get_data_from_id: `${API_ESHOP}/items`,       // eshop:catalogue:get_data_from_id
      promotion_prices_refresh: `${API_ESHOP}/items/promotion-prices/refresh`, // eshop:catalogue:promotion_prices_refresh
      get_catalogue_cfg_data: `${API_BASE}/site/info`,  // eshop:catalogue:get_catalogue_cfg_data
      get_extrainfo_from_id: `${API_ESHOP}/items/extrainfo`, // eshop:catalogue:get_extrainfo_from_id
      template: `${API_ESHOP}/catalogue/template`,      // eshop:catalogue:template
    },
    item_class: {
      list: `${API_ESHOP}/item-class/classes`,                // eshop:item_class:list
      class_attributes: `${API_ESHOP}/item-class/classes`,    // eshop:item_class:class_attributes
    },
    category: {
      tree: `${API_ESHOP}/category/tree`,           // eshop:category:tree
      list: `${API_ESHOP}/category`,                // eshop:category:list
      items: `${API_ESHOP}/category/items`,         // eshop:category:top_items
      highlighted: `${API_ESHOP}/category/highlighted`, // eshop:category:highlighted
      fallback_images: `${API_ESHOP}/category/fallback-images`, // eshop:category:fallback_images
    },
    payment: {
      totals: `${API_ESHOP}/checkout/totals`,                  // eshop:payment:totals
      methods: `${API_ESHOP}/checkout/payment/methods`,       // eshop:payment:methods
    },
    checkout: {
      preview: `${API_ESHOP}/checkout/preview`,         // eshop:checkout:preview
      confirm: `${API_ESHOP}/checkout/confirm`,         // eshop:checkout:confirm
      validate: `${API_ESHOP}/checkout/validate`,       // eshop:checkout:validate
      guest: {
        init: `${API_ESHOP}/checkout/guest/init`,             // eshop:checkout:guest:init
        addresses: `${API_ESHOP}/checkout/guest/addresses`,   // eshop:checkout:guest:addresses
        link: {
          request: `${API_ESHOP}/guest/link/request`,         // eshop:checkout:guest:link:request
          confirm: `${API_ESHOP}/guest/link/confirm`,         // eshop:checkout:guest:link:confirm
        },
      },
      return: `${API_ESHOP}/checkout/return`,                 // eshop:checkout:return
    },
    order: {
      create: `${API_ERP}/sale-orders`,                // eshop:order:create
      by_token: `${API_ERP}/sale-orders/by-token`,     // eshop:order:by_token
      list: `${API_ESHOP}/orders`,                     // eshop:order:list
      public_detail: `${API_ESHOP}/orders/public`,     // eshop:order:public_detail
      public_link: `${API_ESHOP}/orders`,              // eshop:order:public_link
      payment_retry: `${API_ESHOP}/orders`,            // eshop:order:payment_retry
      payment_proof: `${API_ESHOP}/orders`,            // eshop:order:payment_proof
    },
    quotes: {
      public: `${API_ESHOP}/quotes/public`,            // eshop:quotes:public
      confirm: `${API_ESHOP}/quotes/public`,           // eshop:quotes:confirm
    },
  },
  erp: {
    payment: {
      methods: `${API_ERP}/payment/methods`, // erp:payment:methods (list/create/update/delete/toggle)
      cashboxes: `${API_ERP}/cashboxes`, // erp:payment:cashboxes
    },
    cashflow: {
      balance: `${API_ERP}/cashflow/balance`, // erp:cashflow:balance
      balance_export: `${API_ERP}/cashflow/balance/export`, // erp:cashflow:balance_export
      transfer: `${API_ERP}/cashflow/balance/transfer`, // erp:cashflow:transfer
      adjust: `${API_ERP}/cashflow/balance/adjust`, // erp:cashflow:adjust
    },
    cash_session: {
      status: `${API_ERP}/cash-session/status`, // erp:cash_session:status
      open: `${API_ERP}/cash-session/open`, // erp:cash_session:open
      close: `${API_ERP}/cash-session/close`, // erp:cash_session:close
      authorize_close: `${API_ERP}/cash-session/authorize-close`, // erp:cash_session:authorize_close
      tolerance: `${API_ERP}/cash-session/tolerance`, // erp:cash_session:tolerance
    },
    staff: {
      base: `${API_ERP}/staff`, // erp:staff:base (list/create)
      detail: `${API_ERP}/staff`, // erp:staff:detail (append staffId)
      roles: {
        presets: `${API_ERP}/staff/roles/presets`, // erp:staff:roles:presets
        staff_presets: `${API_ERP}/staff/roles/staff`, // erp:staff:roles:staff_presets (append staffId/presets[/presetKey])
      },
      schedules: {
        base: `${API_ERP}/staff/schedules`, // erp:staff:schedules:base (append staffId)
        rules: `${API_ERP}/staff/schedules`, // erp:staff:schedules:rules (append staffId/rules[/ruleId])
        time_off: `${API_ERP}/staff/schedules`, // erp:staff:schedules:time_off (append staffId/time-off[/timeOffId])
      },
    },
    expenses: {
      base: `${API_ERP}/expenses`, // erp:expenses:base
      export: `${API_ERP}/expenses/export`, // erp:expenses:export
      detail: `${API_ERP}/expenses`, // erp:expenses:detail (append expenseId)
      executions: `${API_ERP}/expenses`, // erp:expenses:executions (append expenseId/executions)
      execute: `${API_ERP}/expenses`, // erp:expenses:execute (append expenseId/execute)
      schedule: `${API_ERP}/expenses`, // erp:expenses:schedule (append expenseId/schedule)
      rematerialize: `${API_ERP}/expenses`, // erp:expenses:rematerialize (append expenseId/rematerialize)
    },
    cost_centers: `${API_ERP}/cost-centers`, // erp:cost_centers
    customers: {
      search: `${API_ERP}/pos/customers/search`, // erp:customers:search
      create: `${API_ERP}/pos/customers`, // erp:customers:create
      detail: `${API_ERP}/pos/customers`, // erp:customers:detail
      update: `${API_ERP}/pos/customers`, // erp:customers:update
      delete: `${API_ERP}/pos/customers`, // erp:customers:delete
      balance: `${API_ERP}/customers`, // erp:customers:balance
      balance_adjust: `${API_ERP}/customers`, // erp:customers:balance_adjust
    },
    orders: {
      create: `${API_ERP}/sale-orders`, // erp:orders:create
      list: `${API_ERP}/sale-orders`, // erp:orders:list
      export: `${API_ERP}/sale-orders/export`, // erp:orders:export
      detail: `${API_ERP}/sale-orders`, // erp:orders:detail (append orderId via args)
      actions: {
        mark_paid: `${API_ERP}/sale-orders`, // erp:orders:mark_paid (args → orderId/mark-paid)
        prepare_shipping: `${API_ERP}/sale-orders`, // erp:orders:prepare_shipping (args → orderId/prepare-shipping)
        review_contact: `${API_ERP}/sale-orders`,
        cancel: `${API_ERP}/sale-orders`, // erp:orders:cancel (args → orderId/cancel)
        assign: `${API_ERP}/sale-orders`, // erp:orders:assign (args → orderId/assign)
        notes: `${API_ERP}/sale-orders`, // erp:orders:notes (args → orderId/notes)
      },
      cart_monitor: {
        list: `${API_ERP}/cart-monitor`, // erp:orders:cart_monitor:list
        detail: `${API_ERP}/cart-monitor`, // erp:orders:cart_monitor:detail (append cartId via args)
      },
      discounts: {
        order: `${API_ERP}/sale-orders`, // erp:orders:discounts:order
        line: `${API_ERP}/sale-orders`, // erp:orders:discounts:line
      },
      payments: {
        apply_credit: `${API_ERP}/sale-orders`, // erp:orders:payments:apply_credit
        list: `${API_ERP}/sale-orders`, // erp:orders:payments:list
        add: `${API_ERP}/sale-orders`, // erp:orders:payments:add
        confirm: `${API_ERP}/sale-orders`, // erp:orders:payments:confirm
        confirm_transfer: `${API_ERP}/sale-orders`, // erp:orders:payments:confirm_transfer
        proofs_list: `${API_ERP}/sale-orders`, // erp:orders:payments:proofs_list
        proof_approve: `${API_ERP}/sale-orders`, // erp:orders:payments:proof_approve
        proof_reject: `${API_ERP}/sale-orders`, // erp:orders:payments:proof_reject
        proof_content: `${API_ERP}/sale-orders`, // erp:orders:payments:proof_content
      },
      items: {
        commission_override: `${API_ERP}/sale-orders`, // erp:orders:items:commission_override
      },
    },
    quotes: {
      create: `${API_ERP}/quotes`, // erp:quotes:create
      list: `${API_ERP}/quotes`, // erp:quotes:list
      stats: `${API_ERP}/quotes/stats`, // erp:quotes:stats
      detail: `${API_ERP}/quotes`, // erp:quotes:detail
      cancel: `${API_ERP}/quotes`, // erp:quotes:cancel
      public_link: `${API_ERP}/quotes`, // erp:quotes:public_link
      notify: `${API_ERP}/quotes`, // erp:quotes:notify
      pos_draft: `${API_ERP}/quotes`, // erp:quotes:pos_draft
      opened_in_pos: `${API_ERP}/quotes`, // erp:quotes:opened_in_pos
      mark_converted: `${API_ERP}/quotes`, // erp:quotes:mark_converted
    },
    commissions: {
      agreements: `${API_ERP}/commissions/agreements`, // erp:commissions:agreements
      staff_defaults: `${API_ERP}/commissions/staff-defaults`, // erp:commissions:staff_defaults
      summary: `${API_ERP}/commissions/summary`, // erp:commissions:summary
      list: `${API_ERP}/commissions/list`, // erp:commissions:list
      board: `${API_ERP}/commissions/board`, // erp:commissions:board
    },
    rrhh: {
      agreements: `${API_ERP}/rrhh/agreements`, // erp:rrhh:agreements
      staff_agreements: `${API_ERP}/rrhh/staff`, // erp:rrhh:staff_agreements
      settlements: `${API_ERP}/rrhh/settlements`, // erp:rrhh:settlements
      settlement_draft: `${API_ERP}/rrhh/settlements/draft`, // erp:rrhh:settlement_draft
      settlement_approve: `${API_ERP}/rrhh/settlements`, // erp:rrhh:settlement_approve
      settlement_recalculate: `${API_ERP}/rrhh/settlements`, // erp:rrhh:settlement_recalculate
      settlement_payments: `${API_ERP}/rrhh/settlements`, // erp:rrhh:settlement_payments
      settlement_cancel: `${API_ERP}/rrhh/settlements`, // erp:rrhh:settlement_cancel
      settlement_export: `${API_ERP}/rrhh/settlements/export`, // erp:rrhh:settlement_export
      settlement_receipt: `${API_ERP}/rrhh/settlements`, // erp:rrhh:settlement_receipt
      settlement_detail_export: `${API_ERP}/rrhh/settlements`, // erp:rrhh:settlement_detail_export
    },
    inventory: {
      base: `${API_ERP}/inventory`, // erp:inventory:base
      warehouses: `${API_ERP}/inventory/warehouses`, // erp:inventory:warehouses
      locations: `${API_ERP}/inventory/locations`, // erp:inventory:locations
      quants: `${API_ERP}/inventory/quants`, // erp:inventory:quants
      moves: `${API_ERP}/inventory/moves`, // erp:inventory:moves
      adjustments: `${API_ERP}/inventory/adjustments`, // erp:inventory:adjustments
      bootstrap: `${API_ERP}/inventory/bootstrap`, // erp:inventory:bootstrap
      stock: `${API_ERP}/inventory/stock`, // erp:inventory:stock
      initial_load: `${API_ERP}/inventory/initial-load`, // erp:inventory:initial_load
      receipts: `${API_ERP}/inventory/receipts`, // erp:inventory:receipts
      counts: `${API_ERP}/inventory/counts`, // erp:inventory:counts
      activity: `${API_ERP}/inventory/activity`, // erp:inventory:activity
      alerts: `${API_ERP}/inventory/alerts`, // erp:inventory:alerts
      settings: `${API_ERP}/inventory/settings`, // erp:inventory:settings
    },
    appointments: {
      services: `${API_ERP}/services`, // erp:appointments:services
      professionals: `${API_ERP}/professionals`, // erp:appointments:professionals
      list: `${API_ERP}/appointments`, // erp:appointments:list (C02 multi-service state machine)
      attendees: `${API_ERP}/appointments`, // erp:appointments:attendees (append appointmentId/attendees[/attendeeId])
      clinical_records: `${API_ERP}/appointments/clinical-records`, // erp:appointments:clinical_records
      availability: `${API_ERP}/appointments/availability`, // erp:appointments:availability
      history: `${API_ERP}/appointments`, // erp:appointments:history
      actions: {
        cancel: `${API_ERP}/appointments`, // erp:appointments:actions:cancel (append appointmentId/cancel)
        reactivate: `${API_ERP}/appointments`, // erp:appointments:actions:reactivate (append appointmentId/reactivate)
        charge: `${API_ERP}/appointments`, // erp:appointments:actions:charge (append appointmentId/charge)
      },
      planning: {
        assign: `${API_ERP}/appointments/planning/v2/assign`, // erp:appointments:planning:assign
        reorder: `${API_ERP}/appointments/planning/v2/reorder`, // erp:appointments:planning:reorder
      },
    },
    group_classes: {
      base: `${API_ERP}/group-classes`, // erp:group_classes:base
      events: `${API_ERP}/group-classes/events`, // erp:group_classes:events
      operation: `${API_ERP}/group-classes/events`, // erp:group_classes:operation (append key/operation)
      projection: `${API_ERP}/group-classes/events/projection`, // erp:group_classes:projection
      participants: `${API_ERP}/group-classes/events/participants`, // erp:group_classes:participants
      overrides: `${API_ERP}/group-classes/events/overrides`, // erp:group_classes:overrides
      attendance: {
        present: `${API_ERP}/group-classes/events/attendance/present`, // erp:group_classes:attendance:present
        absent: `${API_ERP}/group-classes/events/attendance/absent`, // erp:group_classes:attendance:absent
        reset: `${API_ERP}/group-classes/events/attendance/reset`, // erp:group_classes:attendance:reset
        reverse: `${API_ERP}/group-classes/events/attendance/reverse`, // erp:group_classes:attendance:reverse
      },
      billing: {
        drop_in_order: `${API_ERP}/group-classes/events/drop-in-order`, // erp:group_classes:billing:drop_in_order
      },
    },
    schedule_activity: `${API_ERP}/schedule-activity`, // erp:schedule_activity:list
    purchasing: {
      purchase_orders: `${API_ERP}/purchase_orders`, // erp:purchasing:purchase_orders
    },
    services: {
      staff: `${API_ERP}/service-staff`, // erp:services:staff
    },
    spaces: {
      list: `${API_ERP}/spaces`, // erp:spaces:list
      assignments: `${API_ERP}/spaces/assignments`, // erp:spaces:assignments
    },
    pos: {
      items: {
        search: `${API_ERP}/pos/items/search`, // erp:pos:items:search
        suggestions: `${API_ERP}/items/suggestions`, // erp:pos:items:suggestions
      },
      promotions: {
        evaluate: `${API_ERP}/pos/promotions/preview`, // erp:pos:promotions:evaluate
      },
      commissions: {
        preview: `${API_ERP}/pos/commissions/preview`, // erp:pos:commissions:preview
      },
    },
    pos_closure: {
      close: `${API_ERP}/pos-closure`,                // erp:pos_closure:close (POST)
      boxes_to_close: `${API_ERP}/pos-closure/boxes-to-close`, // erp:pos_closure:boxes_to_close
      tolerance: `${API_ERP}/pos-closure/tolerance`,  // erp:pos_closure:tolerance
    },
    subscriptions: {
      plans: `${API_ERP}/subscriptions/plans`, // erp:subscriptions:plans
      plans_export: `${API_ERP}/subscriptions/plans/export`, // erp:subscriptions:plans_export
      plans_available: `${API_ERP}/subscriptions/plans/available`, // erp:subscriptions:plans_available
      customer: `${API_ERP}/subscriptions/customer`, // erp:subscriptions:customer
      customer_export: `${API_ERP}/subscriptions/customer/export`, // erp:subscriptions:customer_export
      customer_by_customer: `${API_ERP}/subscriptions/customer/customers`, // erp:subscriptions:customer_by_customer
      usage: `${API_ERP}/subscriptions`, // erp:subscriptions:usage
      reminders: `${API_ERP}/subscriptions/reminders`, // erp:subscriptions:reminders
      scheduler: `${API_BASE}/internal/subscriptions/scheduler`, // erp:subscriptions:scheduler
    },
  },
  crm: {
    customers: {
      list: `${API_CRM}/customers`,             // crm:customers:list
      kpis: `${API_CRM}/customers/kpis`,        // crm:customers:kpis
      export: `${API_CRM}/customers/export`,    // crm:customers:export
      convert_to_staff: `${API_CRM}/customers`, // crm:customers:convert_to_staff (append customerId/convert-to-staff)
    },
    wsp: {
      get_chat_list: `${API_CRM}/wsp/chats`,    // crm:wsp:get_chat_list
      get_msjs: `${API_CRM}/wsp/chats`,         // crm:wsp:get_msjs (append chatId)
      has_new: `${API_CRM}/wsp/chats/has-new`,  // crm:wsp:has_new
    },
    reminders: {
      appointments: `${API_CRM}/reminders/appointments`, // crm:reminders:appointments
      send: `${API_CRM}/reminders/send`,                 // crm:reminders:send
      templates: `${API_CRM}/reminders/templates`,       // crm:reminders:templates
      templates_render: `${API_CRM}/reminders/templates`,// crm:reminders:templates_render (append id/render)
      manual_preview: `${API_CRM}/reminders/manual/preview`,
      manual_open: `${API_CRM}/reminders/manual/open`,
      manual_status: `${API_CRM}/reminders/manual/status`,
    },
  },
  reminders: {
    rules: `${API_BASE}/reminders/rules`,
    instances: `${API_BASE}/reminders/instances`,
    overrides: `${API_BASE}/reminders/overrides`,
    preview: `${API_BASE}/reminders/preview`,
    deliveries: `${API_BASE}/reminders/deliveries`,
  },
  generics: {
    location: {
      get_country_datalist: `${API_BASE}/generics/location/countries`,    // generics:location:get_country_datalist
      get_state_datalist: `${API_BASE}/generics/location/states`,         // generics:location:get_state_datalist
      get_city_datalist: `${API_BASE}/generics/location/cities`,          // generics:location:get_city_datalist
      get_postcode_datalist: `${API_BASE}/generics/location/postcodes`,   // generics:location:get_postcode_datalist
      get_state: `${API_BASE}/generics/location/states`,                  // generics:location:get_state
      get_city_by_postal: `${API_BASE}/generics/location/cities/postal`,  // generics:location:get_city_by_postal
    },
  },
  conns: {
    wsp: {
      status: `${API_BASE}/conns/wsp/status`,
      login: `${API_BASE}/conns/wsp/login`,
      logout: `${API_BASE}/conns/wsp/logout`,
    }
  },
  site: {
    info: `${API_BASE}/site/info`,                    // site:info
  },
  cms: {
    pages: `${API_BASE}/cms/pages`,                   // cms:pages
    pages_reader: `${API_BASE}/cms/pages-reader`,     // cms:pages_reader
    legacy_web: `${API_BASE}/cms/legacy-web`,         // cms:legacy_web
    site_templates: `${API_BASE}/cms/site-templates`, // cms:site_templates
  },
  events: {
    ingest: `${API_BASE}/events`,                     // events:ingest
  },
  assistant: {
    capabilities: `${API_BASE}/assistant/capabilities`, // assistant:capabilities
    support: `${API_BASE}/assistant/support`, // assistant:support
    settings: `${API_BASE}/assistant/settings`, // assistant:settings
    audit: {
      metrics: `${API_BASE}/assistant/audit/metrics`, // assistant:audit:metrics
      conversations: `${API_BASE}/assistant/audit/conversations`, // assistant:audit:conversations
    },
    session: {
      start: `${API_BASE}/assistant/session/start`,  // assistant:session:start
      message: `${API_BASE}/assistant/session`,      // assistant:session:message (append sessionId/message)
      history: `${API_BASE}/assistant/session`,      // assistant:session:history (append sessionId/history)
      end: `${API_BASE}/assistant/session`,          // assistant:session:end (append sessionId/end)
      feedback: `${API_BASE}/assistant/session`,     // assistant:session:feedback (append sessionId/messages/messageId/feedback)
    },
    actions: {
      available: `${API_BASE}/assistant/actions/available`, // assistant:actions:available
      resolve: `${API_BASE}/assistant/session`, // assistant:actions:resolve
    },
  },
};

export { URLScheme, API_BASE, DASHBOARD_BASE, API_ESHOP, DASHBOARD_ESHOP, API_ERP };
